<template>
  <v-card
      v-if="group"
      @click="$emit('change-enabling')"
      class=" mx-auto"
      :color="group && group.is_enabled ? '#e9f7ec' : null"
      :max-width="$vuetify.breakpoint.mdAndUp ? 250 : null"
      :min-width="250"
      :min-height="height"

      outlined
  >
    <v-list-item three-line>
      <v-list-item-content class="pb-0 mb-0">
        <v-list-item-title class="text-h5 mb-1 pb-0">
          <v-container fluid class="pa-0 ma-0 py-0">
            <v-row dense >
              <v-col>
                <v-tooltip bottom :color="group && group.is_enabled ? '#e9f7ec' : 'primary'">
                  <template v-slot:activator="{ on, attrs }">
                    <span   v-bind="attrs"
                            v-on="on">
                    <v-chip
                        x-small
                        class="px-2 mx-0 mb-1"
                        color="success"
                        v-if="groups.status == 1"
                    />
                    <v-chip class="px-2 mx-0 mb-1" x-small x-small color="error" v-else/>
                      </span>
                  </template>
                  <span>{{ groups.bill_end }}</span>
                </v-tooltip>

                #{{ group.group_id }}</v-col>
              <v-col class="text-end pr-2">
                <span

                      :class="{
                        'text-decoration-line-through':(isOriginal && isEnabledAllOriginal) || (isSpecial && isEnabledAllSpecial),
                        'caption':(isOriginal && isEnabledAllOriginal) || (isSpecial && isEnabledAllSpecial),
                        'mx-2':(isOriginal && isEnabledAllOriginal) || (isSpecial && isEnabledAllSpecial),
                        'red--text':(isOriginal && isEnabledAllOriginal) || (isSpecial && isEnabledAllSpecial)
                      }"
                >{{ group.price_per_month }}</span>
                <span v-if="(isOriginal && isEnabledAllOriginal) || (isSpecial && isEnabledAllSpecial)">{{ group.price_per_month_with_discount.toFixed(2) }}</span>
                <v-icon class="d-inline-flex">{{ currency === 'eur' ? "mdi-currency-eur" : "mdi-currency-rub"}}</v-icon>
              </v-col>
            </v-row>
          </v-container>


        </v-list-item-title>
        <div :style="{height:isSpecial?'83px':'auto'}">
          <v-tooltip bottom color="primary" v-for="catalogGroup in groups.catalog_groups">
            <template v-slot:activator="{ on, attrs }">
              <v-img
                  v-bind="attrs"
                  v-on="on"
                  class="d-inline-flex ml-0 mr-1"
                  max-height="39"
                  max-width="39"
                  :src="logoPath + catalogGroup.logo"
                  :key="catalogGroup.id"
              ></v-img>
            </template>
            <span>{{ catalogGroup.name }}</span>
          </v-tooltip>

        </div>
      </v-list-item-content>

    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "catalogGroupTile",
  props: {
    isEnabledAllOriginal: null,
    isEnabledAllSpecial: null,
    isOriginal: null,
    isSpecial: null,
    group: null,
    groups: null,
    height: null,
    currency: null,
  },
  data:()=>({
    logoPath: process.env.VUE_APP_BRANDS_MINI_PATH
  })
}
</script>

<style scoped>

</style>